import { createEnv } from "@t3-oss/env-nextjs"
import { z } from "zod"

export const env = createEnv({
  /**
   * SERVER-ONLY
   * Nunca será exposto para o client
   */
  server: {
    WOOCOMMERCE_CONSUMER_KEY: z.string().min(1),
    WOOCOMMERCE_CONSUMER_SECRET: z.string().min(1),
    DATABASE_URL: z.url().optional(),
    WP_API_URL: z.url(),
    WCF_CHECKOUT_ID: z.string().regex(/^\d+$/),
    NODE_TLS_REJECT_UNAUTHORIZED: z.string().optional(),
  },

  /**
   * CLIENT + SERVER
   * Obrigatoriamente começa com NEXT_PUBLIC_
   */
  client: {
    NEXT_PUBLIC_SITE_URL: z.url().optional(),
    NEXT_PUBLIC_ENV: z
      .enum(["development", "staging", "production"])
      .optional(),
    NEXT_PUBLIC_WP_API_URL: z.url(),
    NEXT_PUBLIC_WP_IMAGE_BASE_DEV: z.url(),
    NEXT_PUBLIC_WHATSAPP_NUMBER: z.string().regex(/^\d+$/),
  },

  /**
   * Mapeamento real do process.env
   */
  runtimeEnv: {
    WOOCOMMERCE_CONSUMER_KEY: process.env.WOOCOMMERCE_CONSUMER_KEY,
    WOOCOMMERCE_CONSUMER_SECRET: process.env.WOOCOMMERCE_CONSUMER_SECRET,
    DATABASE_URL: process.env.DATABASE_URL,
    WP_API_URL: process.env.WP_API_URL,
    WCF_CHECKOUT_ID: process.env.WCF_CHECKOUT_ID,
    NODE_TLS_REJECT_UNAUTHORIZED: process.env.NODE_TLS_REJECT_UNAUTHORIZED,

    NEXT_PUBLIC_SITE_URL: process.env.NEXT_PUBLIC_SITE_URL,
    NEXT_PUBLIC_ENV: process.env.NEXT_PUBLIC_ENV,
    NEXT_PUBLIC_WP_API_URL: process.env.NEXT_PUBLIC_WP_API_URL,
    NEXT_PUBLIC_WP_IMAGE_BASE_DEV: process.env.NEXT_PUBLIC_WP_IMAGE_BASE_DEV,
    NEXT_PUBLIC_WHATSAPP_NUMBER: process.env.NEXT_PUBLIC_WHATSAPP_NUMBER,
  },
})
